import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card, CardContent, CardHeader, CircularProgress, Hidden, useTheme } from '@material-ui/core';
import { getModalidadesMaisUsadas, getVisitasPorMes } from '../../../../../services/DashboardService';
import Chart from 'react-apexcharts';
import { IOSSwitch } from '../../../../../components/';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';


const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 20,
    minHeight: '100%'
  },
  chartContainer: {
    minHeight: 400,
    position: 'relative'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const GraficoModalidadesMaisUsadas = props => {
  const { className, ...rest } = props;
  const theme = useTheme();
  const [modalidadesMaisUsadas, setModalidadesMaisUsadas] = useState([]);
  const [mostrarProgress, setMostrarProgress] = useState(true);
  const [mostrarAlertaErro, setMostrarAlertaErro] = useState(false);
  const [labels, setLabels] = useState([]);
  const [qtdModalidades, setQtdModalidades] = useState([]);
  const [mostrarAnaliseDetalhada, setMostrarAnaliseDetalhada] = useState(true);

  const classes = useStyles();

  useEffect(() => {
    try {
      getDados();
    }
    catch (e) {

    }
  }, []);

  async function getDados() {
    try {
      setMostrarProgress(true);
      let dados = await getModalidadesMaisUsadas();
      if (dados.isSuccess) {
        setMostrarProgress(false);
        setModalidadesMaisUsadas(dados.result);
        let novasLabels = [];
        let novasQtdModalidades = [];
        dados.result.map(modalidade => {
          novasLabels.push([modalidade.descricao]);
          novasQtdModalidades.push(modalidade.totalModalidade);
        });
        setLabels(novasLabels);
        setQtdModalidades(novasQtdModalidades);

      } else {
        setMostrarProgress(false);
        setMostrarAlertaErro(true);
      }
    } catch (e) {
      setMostrarProgress(false);
      setMostrarAlertaErro(true);
    }
  }

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
      elevation={3}
    >
      <CardHeader
        title="Modalidades mais usadas"
      />
      <CardContent
      >
        <Grid
          container
        >
          {
            mostrarProgress &&
            <Grid
              container
              style={{
                display: 'flex',
                justifyContent: 'center',
                height: '100%'
              }}
            >
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  height: '100%',
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <div className={classes.chartContainer}>
                  <CircularProgress
                  />
                </div>
              </Grid>
            </Grid>
          }
          {
            !mostrarProgress &&
            <Grid
              item
              md={12}
              xs={12}

            >
              <div className={classes.chartContainer}>
                <Chart
                  options={{
                    chart: {
                      height: 350,
                      type: 'bar',
                      toolbar: {
                        show: false
                      },
                    },
                    colors: [theme.palette.info.main, theme.palette.warning.main, theme.palette.success.main, theme.palette.primary.main],
                    plotOptions: {
                      bar: {
                        columnWidth: '35%',
                        distributed: true,
                      }
                    },
                    dataLabels: {
                      enabled: true,
                      formatter: function (val) {
                        return val;
                      },
                      style: {
                        fontSize: '12px',
                        colors: ["#FFFFFF"]
                      }
                    },
                    legend: {
                      show: false
                    },
                    yaxis: {
                      title: {
                        text: 'Quantidade'
                      },
                    },
                    xaxis: {
                      categories: labels,
                      labels: {
                        style: {
                          fontSize: '12px'
                        }
                      },
                    }
                  }}
                  type={'bar'}
                  series={[{
                    name: 'Quantidade',
                    data: qtdModalidades
                  }]}
                  height={400}
                />
              </div>
            </Grid>
          }
        </Grid>
      </CardContent>
    </Card>
  );
};

GraficoModalidadesMaisUsadas.propTypes = {
  className: PropTypes.string
};

export default GraficoModalidadesMaisUsadas;
